/**
 * Automatically adds gift-with-purchase items to the cart when their eligibility rule is met,
 * and removes them again once it stops being met. Each gift's actual €0 price comes from its
 * own Shopify automatic discount scoped to that variant — this script only keeps the line
 * items themselves in sync with the cart's contents.
 */
(function () {
  var combinaisonsProductIds = (window.theme && window.theme.giftWithPurchase && window.theme.giftWithPurchase.combinaisonsProductIds) || [];

  var GIFT_RULES = [
    {
      // Totebag: offered for any order.
      variantId: 52671964250376,
      isEligible: function (cart, giftVariantIds) {
        return cart.items.some(function (item) {
          return giftVariantIds.indexOf(item.variant_id) === -1;
        });
      }
    },
    {
      // Set écharpe & bonnet: offered only when a product from the "Combinaisons" collection is in the cart.
      variantId: 59106511225096,
      isEligible: function (cart) {
        return cart.items.some(function (item) {
          return combinaisonsProductIds.indexOf(item.product_id) !== -1;
        });
      }
    }
  ];

  var GIFT_VARIANT_IDS = GIFT_RULES.map(function (rule) { return rule.variantId; });
  var syncing = false;

  function getCart() {
    return fetch('/cart.js').then(function (response) { return response.json(); });
  }

  function addGift(variantId) {
    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { _free_gift: 'true' }
      })
    });
  }

  function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  function announceCartChange() {
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
  }

  function syncFreeGifts() {
    if (syncing) return;
    syncing = true;

    getCart()
      .then(function (cart) {
        var actions = GIFT_RULES.map(function (rule) {
          var line = cart.items.find(function (item) { return item.variant_id === rule.variantId; });
          var eligible = rule.isEligible(cart, GIFT_VARIANT_IDS);

          if (eligible && !line) return function () { return addGift(rule.variantId); };
          if (!eligible && line) return function () { return removeGift(line.key); };
          return null;
        }).filter(Boolean);

        if (actions.length === 0) return null;

        return actions
          .reduce(function (promise, action) { return promise.then(action); }, Promise.resolve())
          .then(announceCartChange);
      })
      .catch(function (error) {
        console.error('[free-gift]', error); // eslint-disable-line
      })
      .finally(function () {
        syncing = false;
      });
  }

  document.addEventListener('on:cart:add', syncFreeGifts);
  document.addEventListener('on:cart:change', syncFreeGifts);
  document.addEventListener('DOMContentLoaded', syncFreeGifts);
})();
